import { config } from "common/config";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { es } from "./locales/es/es";
import LanguageDetectorPlugin from "./plugins/LanguageDetectorPlugin";

export const defaultNS = "translation";

export const resources = {
    es
} as const;

export const i18nextInitializationPromise = i18next
    .use(initReactI18next)
    .use(LanguageDetectorPlugin)
    .init({
        fallbackLng: config.defaultLocale,
        resources,
        debug: process.env.NODE_ENV === "development",
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        returnNull: false,
    });

export default i18next;
